import { render } from "./D3ForceGraph.vue?vue&type=template&id=50943de9&scoped=true"
import script from "./D3ForceGraph.vue?vue&type=script&lang=js"
export * from "./D3ForceGraph.vue?vue&type=script&lang=js"

import "./D3ForceGraph.vue?vue&type=style&index=0&id=50943de9&scoped=true&lang=css"
import "./D3ForceGraph.vue?vue&type=style&index=1&id=50943de9&lang=scss"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50943de9"]])

export default __exports__